import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 32px;
  width: 32px;
`
export const MapIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className={className}>
      <path d="M19.9993 27.2828L11.9993 24.4828L6.26102 26.7031C5.8679 26.8553 5.50379 26.8118 5.16868 26.5724C4.83357 26.3331 4.66602 26.0058 4.66602 25.5904V8.10342C4.66602 7.84008 4.73657 7.60375 4.87768 7.39442C5.01857 7.18508 5.21646 7.03342 5.47135 6.93942L11.9993 4.71875L19.9993 7.51875L25.7377 5.29842C26.1308 5.14619 26.4949 5.18331 26.83 5.40975C27.1651 5.6362 27.3327 5.95286 27.3327 6.35975V23.9494C27.3327 24.2212 27.2558 24.4596 27.102 24.6648C26.948 24.8699 26.7395 25.0194 26.4763 25.1134L19.9993 27.2828ZM18.9993 24.8368V9.23675L12.9993 7.13909V22.7391L18.9993 24.8368ZM20.9993 24.8368L25.3327 23.4008V7.60075L20.9993 9.23675V24.8368ZM6.66602 24.4008L10.9993 22.7391V7.13909L6.66602 8.60075V24.4008Z" />
    </Svg>
  )
}
